import React from 'react'
import LPHeader from 'src/components/layout/Header/LPHeader'
import ButtonCustom from 'src/components/form/Button'
import { useNavigate } from 'react-router-dom'
import ShampooHeader from 'src/components/layout/Header/ShampooHeader'
import { PATH } from 'src/pages/myPage'
import { HeaderStyle } from 'src/components/layout/Header/HeaderStyle'
import DescriptionHint from 'src/components/layout/Content/DescriptionHint'

const StatusErrorContainer: React.FC = () => {
  const navigate = useNavigate()

  const handleMyPage = () => {
    navigate(PATH.OTHER_MENU)
  }

  return (
    <>
      <LPHeader />
      <div className="w-full justify-center mx-auto layout-webview-step register-form not-padding-p">
        <ShampooHeader name="バノバギイレブン 運営事務局" className="top-70" />
        <HeaderStyle>申し訳ございません。</HeaderStyle>
        <DescriptionHint
          listText={[
            'すでにお手続きが進んでおります。',
            '<br />',
            '以下の「マイページ」ボタンをタップしていただき、引き続きお手続きを継続してください。',
          ]}
        />

        <ButtonCustom
          className="btn-default btn-black mt-5 btn-submit"
          loading={false}
          onClick={handleMyPage}
          name="マイページ"
        />
      </div>
    </>
  )
}

export default StatusErrorContainer
